import { ImageInputCropper } from '@shared/ui/index';
import type { ImageInputCropperProps } from '@shared/ui/inputs/image-input-cropper/ui';

export type ImageInputCropperMPT = Partial<ImageInputCropperProps> & {
  error?: string;
};
export const ImageInputCropperM = ({ error, isValid, ...props }: ImageInputCropperMPT) => {
  return <ImageInputCropper isValid={!!error} {...props} />;
};
